module.exports = __webpack_public_path__ + "img/foravila-rentals-logo.add98366.svg";